__webpack_require__.p = "https://cdn-teacher.writinglegends.com/_next/";